import CustomCantidadRecibidaInput from "@/shared/components/ui/CustomCantidadRecibidaInput"
import { MaterialTransferido } from "@/shared/interfaces"
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store"
import { IconButton, Tooltip } from "@mui/material"
import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import DeleteIcon from '@mui/icons-material/Delete';

export default function useTableDetalleProductoRevisionSolicitud() {
  const handleEliminarProducto = useCargarSeriesProductos(s => s.handleEliminarProducto)
  //store
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)

  const infoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        accessorKey: 'accion',
        header: 'Accion',
        size: 10,
        Cell: ({ row }) => {
          return (
            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  handleEliminarProducto(row.original.id!)
                }}
              >
                <DeleteIcon />
              </IconButton>

            </Tooltip>
          )
        }
      },
      {
        accessorKey: 'cantidad',
        header: 'Cant. requerida'
      },
      {
        accessorKey: 'cantidad_aprobada',
        header: 'Cant. a Aprobar',
        Cell: ({ row }) => {
          const cantidadMaxima = Number(row.original.cantidad)
          return (
            <CustomCantidadRecibidaInput
              value={Number(row.original.cantidad_aprobada) || 0}
              maxValue={cantidadMaxima}
              handleValue={(value) => {
                handleActualizarProducto(row.original.id, {
                  ...row.original,
                  cantidad_aprobada: value
                })
              }}
              row={row}
            />
          )
        }
      },
      {
        accessorKey: 'codigo',
        header: 'Codigo',
        Cell: ({ row }) => row.original.codigo || 'N/A',
      },
      {
        accessorKey: 'producto_data.descripcion',
        header: 'Descripción'
      },
      {
        accessorKey: 'producto_data.unidad_medida',
        header: 'Unidad Medida',
        Cell: ({ row }) => row.original.producto_data?.unidad_medida || 'N/A'
      },
      {
        accessorKey: 'producto_data.stock_actual',
        header: 'Stock Actual'
      },
      {
        accessorKey: 'producto_data.modelo_producto',
        header: 'Modelo',
        Cell:({row})=> row.original?.producto_data?.modelo_producto || 'N/A'
      },
      {
        accessorKey: 'producto_data.marca_producto',
        header: 'Marca'
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria'
      }
    ], []
  )
  return {
    infoProducto
  }
}